import { render, staticRenderFns } from "./DSSidebar.vue?vue&type=template&id=56ed6cde&"
import script from "./DSSidebar.vue?vue&type=script&lang=js&"
export * from "./DSSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports